var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartIcon = function SvgHeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.636 5.4a4.102 4.102 0 0 1-1.174 2.895L14.95 9.834l-4.934 5.018a1.066 1.066 0 0 1-1.532 0L3.55 9.834 2.04 8.295A4.102 4.102 0 0 1 .865 5.401c0-1.264.559-2.527 1.693-3.353 1.635-1.19 3.892-.862 5.317.588L9.216 4a.047.047 0 0 0 .068 0l1.34-1.363c1.426-1.45 3.683-1.778 5.318-.587a4.109 4.109 0 0 1 1.694 3.35Z",
    stroke: "#362B24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeartIcon;